/* eslint-disable no-underscore-dangle */
/* eslint-disable no-shadow */
/* eslint-disable no-alert */

import React, { useEffect, useCallback, useState } from 'react';
import styled from 'styled-components';
import { Column } from 'rbx';
import { first, isNaN, toLower, isNull, forEach } from 'lodash';
import voucher_codes from 'voucher-code-generator';
import moment from 'moment-timezone';
import ReactLoading from 'react-loading';

import {
  Select,
  Radio,
  Input,
  CheckBox,
  BoxWithHeader,
  InputAddOn,
} from '../../../components/elements';

import DealTimeDatePicker from './DealTimeDatePicker';
import ItemsAndVariantsDiscount from './ItemsAndVariantsDiscount';
import {
  parseLinkAndMenuItem,
  getLinksAndMenuItem,
  onAddItems,
} from './helpers';
import AddCategoryModal from './AddCategoryModal';
// import SearchItemModal from '../../MenuManagement/Section/SearchItemModal';

import SearchItemModal from './ItemsAndVariantsDiscount/SearchItemModal';

import CategoryDealDiscount from './CategoryDealDiscount';
import BogoItems from './BogoItems';

const mergeLinkAndCategoryMenuItem = (link, menuItemObj) => {
  if (menuItemObj.__typename) {
    const data = {
      item_link_id: link.item_link_id,
      menu_item_id: link.menu_item_id,
      name: link.name,
      menu_item_price: link.menu_item_price,
      menu_section_name: link.menu_section_name,
      menu_section_id: link.menu_section_id,
    };
    if (isNull(menuItemObj.variant)) {
      return {
        ...data,
        type: menuItemObj.type || 'PERCENTAGE',
        value: menuItemObj.value || 0,
        new_price: menuItemObj.new_price || link.menu_item_price,
        savings: menuItemObj.savings || 0,
      };
    }

    const itemVariantsFromMenuObj = menuItemObj.variant[0].variants;

    const temp = [];
    forEach(link.variant, item => {
      const temp2 = [];
      forEach(item.variants, item2 => {
        const newVariant = {
          ...item2,
          type:
            itemVariantsFromMenuObj.find(
              ele => ele.variant_id === item2.variant_id,
            ).type || 'PERCENTAGE',
          value:
            itemVariantsFromMenuObj.find(
              ele => ele.variant_id === item2.variant_id,
            ).value || 0,
          savings:
            itemVariantsFromMenuObj.find(
              ele => ele.variant_id === item2.variant_id,
            ).savings || 0,
          new_price:
            itemVariantsFromMenuObj.find(
              ele => ele.variant_id === item2.variant_id,
            ).new_price || item2.variant_price,
        };
        temp2.push(newVariant);
      });
      temp.push({
        prompt_id: item.prompt_id,
        prompt: item.prompt,
        variants: temp2,
      });
    });

    data.variant = temp;
    return data;
  }
  return menuItemObj;
};

const mergeLinksAndMenuItem = (links, menuItem) =>
  links.map(parseLinkAndMenuItem(menuItem));

const status = [
  { value: 'ACTIVE', label: 'ACTIVE' },
  { value: 'INACTIVE', label: 'INACTIVE' },
];

const Flex = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 0.5rem;
`;

const RadioWrapper = styled.div`
  padding: 0rem 0.3rem;
`;

const CheckBoxWrapper = styled.div``;

const LoaderWrapper = styled.div`
  position: relative;
  left: 50%;
  right: 50%;
  opacity: 0.5;
  z-index: 1000;
`;

const VoucherDetails = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  setFieldValue,
  dealType,
  menuName,
  menuId,
  place,
  deliveryChannel,
  isUpdate,
}) => {
  const [addItemModalIsActive, setAddItemModalIsActive] = React.useState(false);
  const [addGetItemModalIsActive, setAddGetItemModalIsActive] = React.useState(
    false,
  );
  const [
    addCategoryModalIsActive,
    setAddCategoryModalIsActive,
  ] = React.useState(false);
  const [autoGenerateRadioValue, setAutoGenerateRadioValue] = useState(true);
  const defaultCouponCode = voucher_codes.generate({
    length: 10,
    count: 1,
    charset: voucher_codes.charset('alphabetic'),
  });
  const [links, setLinks] = useState([]);
  const [linksLoading, setLinksLoading] = useState(false);
  const [addItemsSubmitting, setAddItemsSubmitting] = React.useState(false);
  const [
    disableMaximumFreeQuantity,
    setDisableMaximumFreeQuantity,
  ] = React.useState(false);

  const isBogo = values.deal_type === 'buy_one_get_one_promo';

  const minimumItemPrice = values?.menu_item?.[0]?.menu_item_price;

  const minimumVariantPrice = values?.menu_item?.[0]?.variant?.[0]?.variants?.reduce?.(
    (p, c) => {
      const temp = c.variant_price;
      return Math.min(p, temp);
    },
    Infinity,
  );

  const minimumPrice = minimumVariantPrice || minimumItemPrice;

  useEffect(() => {
    if (
      !values.name &&
      toLower(values.deal_type) === 'specific_item_discount'
    ) {
      setFieldValue('name', 'More savings on select items');
    }
  }, []);

  useEffect(() => {
    if (values.offer_details === 'BUY_X_GET_Y_FROM_LIST') {
      setFieldValue('maximum_free_quantity', 99);
      setDisableMaximumFreeQuantity(true);
    } else if (!values.maximum_free_quantity) {
      setFieldValue('maximum_free_quantity', 1);
      setDisableMaximumFreeQuantity(false);
    } else {
      setDisableMaximumFreeQuantity(false);
    }
  }, [values.offer_details]);

  useEffect(() => {
    if (values.offer_details === 'BUY_X_GET_Y_FROM_LIST') {
      setFieldValue('name', `Buy 1 get a free item`);
    }

    if (values.offer_details === 'BUY_X_GET_Y_SAME_ITEM') {
      setFieldValue('name', `Buy 1 get 1 free`);
    }

    if (values.offer_details === 'BUY_X_GET_Y_BILL_HIGH_PRICE') {
      setFieldValue(
        'name',
        `Buy ${values.buy_quantity ? values.buy_quantity : ''} get ${
          values.get_quantity ? values.get_quantity : ''
        } free items`,
      );
    }
  }, [
    values.name,
    values.offer_details,
    values.buy_quantity,
    values.get_quantity,
  ]);

  const fetchLinks = useCallback(async value => {
    if (!(toLower(values.deal_type) === 'specific_item_discount' || isBogo)) {
      return;
    }

    try {
      const response = await getLinksAndMenuItem(
        {
          sort: 'NAME_ASC',
          from: 0,
          size: 1000,
          // search_criteria: 'Chicken',
          // user_id: userId,
          filter: {
            menu_item_link_filter: {
              place_id: place.place_id,
              menu_id: menuId,
              status: 'ACTIVE',
            },
          },
        },
        {
          sort: 'NAME_ASC',
          from: 0,
          size: 1000,
          filter: {
            menu_item_filter: {
              place_id: place.place_id,
              status: 'ACTIVE',
            },
            menu_filter: {
              menu_id: menuId,
              name: value,
            },
          },
        },
      );
      setLinks(
        mergeLinksAndMenuItem(
          response.search_menu_item_links.menu_item_link_listing,
          response.search_menu_items.menu_item_listing,
        ),
      );

      if (!values.linksForCategoryIsDirty) {
        const links = mergeLinksAndMenuItem(
          response.search_menu_item_links.menu_item_link_listing,
          response.search_menu_items.menu_item_listing,
        );

        setFieldValue(
          'linksForCategory',
          links.map(ele => {
            const item = values.categoryMenuItems.find(
              ele2 => ele2.menu_item_id === ele.menu_item_id,
            );

            if (item) {
              return mergeLinkAndCategoryMenuItem(ele, item);
            }

            return ele;
          }),
        );

        const t = links.map(
          ele =>
            values.categoryMenuItems.find(
              ele2 => ele2.menu_item_id === ele.menu_item_id,
            ) || ele,
        );

        console.log('linksForCategory', t);
      }
    } catch (err) {
      console.error(err);
    }
  }, []);

  useEffect(() => {
    setLinksLoading(true);
    fetchLinks().then(() => setLinksLoading(false));
  }, []);

  useEffect(() => {
    if (isBogo && values.customer_type === 'NEW_CUSTOMER') {
      setFieldValue('customer_type', 'EXISTING');
    }
  }, [isBogo]);

  return (
    <>
      <Column.Group vcentered multiline>
        <Column size={3}>
          <Input label="Discount Type" value={dealType} disabled />
        </Column>
        <Column size={3}>
          <Input label="Menu" value={menuName} disabled />
        </Column>
        <Column size={3}>
          <Select
            label="Deal / Voucher Status"
            options={status}
            value={[{ value: values.status, label: values.status }]}
            onChange={({ value }) => setFieldValue('status', value)}
          />
        </Column>
        {!!deliveryChannel &&
          toLower(values.deal_type) === 'delivery_fee_discount' && (
            <Input label="Delivery Channel" value={deliveryChannel} disabled />
          )}
      </Column.Group>
      <CheckBox
        label="Mobile Only Deal"
        value={values.mobile_only}
        onChange={value => {
          setFieldValue('mobile_only', value);
        }}
      />
      <BoxWithHeader title="Deal / Voucher Type">
        <Column.Group vcentered multiline>
          <Column size={3}>
            <RadioWrapper>
              <Radio
                label="Automatic Promotion"
                value={values.promotion === 'AUTOMATIC'}
                onChange={value => {
                  if (value) {
                    setFieldValue('promotion', 'AUTOMATIC');
                    setFieldValue('is_published', true);
                  }
                }}
              />
            </RadioWrapper>
          </Column>
          {!(
            values.offer_details === 'BUY_X_GET_Y_FROM_LIST' ||
            values.offer_details === 'BUY_X_GET_Y_SAME_ITEM' ||
            values.offer_details === 'BUY_X_GET_Y_BILL_HIGH_PRICE'
          ) && (
            <>
              <Column size={3}>
                <RadioWrapper>
                  <Radio
                    label="Requires Voucher Code"
                    value={values.promotion === 'PROMOCODE'}
                    onChange={value => {
                      if (value) {
                        setFieldValue('promotion', 'PROMOCODE');
                        const coupon = voucher_codes.generate({
                          length: 10,
                          count: 1,
                          charset: voucher_codes.charset('alphabetic'),
                        });
                        setFieldValue(
                          'promo_code',
                          first(coupon).toUpperCase(),
                        );
                        // setFieldValue('is_published', false);
                      }
                    }}
                  />
                </RadioWrapper>
              </Column>

              <Column size={3}>
                <CheckBoxWrapper>
                  {values.promotion === 'PROMOCODE' && (
                    <>
                      <CheckBox
                        label="Auto generate Voucher Code"
                        value={autoGenerateRadioValue}
                        onChange={value => {
                          if (value) {
                            const coupon = voucher_codes.generate({
                              length: 10,
                              count: 1,
                              charset: voucher_codes.charset('alphabetic'),
                            });
                            setFieldValue(
                              'promo_code',
                              first(coupon).toUpperCase(),
                            );
                            setAutoGenerateRadioValue(true);
                          } else {
                            setAutoGenerateRadioValue(false);
                          }
                        }}
                      />
                      <Input
                        name="promo_code"
                        value={values.promo_code}
                        onChange={handleChange}
                        onBlur={e => {
                          if (e.target.value === '') {
                            setFieldValue(
                              'promo_code',
                              first(defaultCouponCode).toUpperCase(),
                            );
                          } else {
                            setFieldValue('promo_code', e.target.value);
                          }
                        }}
                        errors={errors.promo_code}
                        touched={touched.promo_code}
                        disabled={autoGenerateRadioValue}
                      />
                    </>
                  )}
                </CheckBoxWrapper>
              </Column>
            </>
          )}
          <Column size={3}>
            <br />
            {values.promotion !== 'AUTOMATIC' && (
              <CheckBox
                label="Publish voucher /deal"
                value={values.is_published}
                onChange={value => setFieldValue('is_published', value)}
              />
            )}
          </Column>
        </Column.Group>
      </BoxWithHeader>
      <BoxWithHeader title="Choose audience">
        <Column.Group vcentered>
          <Column size={3}>
            <RadioWrapper>
              <Radio
                label="All customers"
                value={values.customer_type === 'EXISTING'}
                onChange={value => {
                  if (value) {
                    setFieldValue('customer_type', 'EXISTING');
                  }
                }}
              />
            </RadioWrapper>
          </Column>
          {!isBogo && (
            <Column size={3}>
              <RadioWrapper>
                <Radio
                  label="New customers"
                  value={values.customer_type === 'NEW_CUSTOMER'}
                  onChange={value => {
                    if (value) {
                      setFieldValue('customer_type', 'NEW_CUSTOMER');
                    }
                  }}
                />
              </RadioWrapper>
            </Column>
          )}
          <Column size={3}>
            <RadioWrapper>
              <CheckBox
                label="Can be clubbed with other discount"
                value={values.can_be_clubbed}
                onChange={value => setFieldValue('can_be_clubbed', value)}
              />
            </RadioWrapper>
          </Column>
        </Column.Group>
      </BoxWithHeader>
      {!isBogo && (
        <BoxWithHeader title="Offer Details">
          <Column.Group vcentered>
            {toLower(values.deal_type) === 'delivery_fee_discount' && (
              <Column size={10}>
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <RadioWrapper>
                    <Radio
                      label="Free Delivery"
                      value={values.free_delivery}
                      onChange={value => {
                        setFieldValue('free_delivery', value);
                        setFieldValue('value', 1);
                      }}
                    />
                  </RadioWrapper>
                  <RadioWrapper>
                    <Radio
                      label="Flat Amount Discount"
                      value={
                        values.fee_type === 'FLAT' && !values.free_delivery
                      }
                      onChange={() => {
                        if (
                          values.fee_type === 'FLAT' &&
                          !values.free_delivery
                        ) {
                          // pass
                        } else {
                          setFieldValue('fee_type', 'FLAT');
                          setFieldValue('free_delivery', false);
                          setFieldValue('value', null);
                        }
                      }}
                    />
                  </RadioWrapper>
                  <RadioWrapper>
                    <Radio
                      label="Percentage Discount"
                      value={
                        values.fee_type === 'PERCENTAGE' &&
                        !values.free_delivery
                      }
                      onChange={() => {
                        if (
                          values.fee_type === 'PERCENTAGE' &&
                          !values.free_delivery
                        ) {
                          // pass
                        } else {
                          setFieldValue('fee_type', 'PERCENTAGE');
                          setFieldValue('free_delivery', false);
                          setFieldValue('value', null);
                        }
                      }}
                    />
                  </RadioWrapper>
                </div>
                {values.fee_type === 'FLAT' && !values.free_delivery && (
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      marginTop: '1rem',
                    }}
                  >
                    <InputAddOn
                      addonsText="$"
                      isLeft
                      required
                      type="number"
                      min="0"
                      label="Minimum purchase amount"
                      value={values.minimum_purchase_amount}
                      onBlur={e => {
                        if (e.target.value === '') {
                          setFieldValue('minimum_purchase_amount', null);
                        } else if (!isNaN(parseFloat(e.target.value))) {
                          setFieldValue(
                            'minimum_purchase_amount',
                            parseFloat(e.target.value).toFixed(2),
                          );
                        }
                      }}
                      onChange={e => {
                        if (e.target.value === '') {
                          setFieldValue('minimum_purchase_amount', null);
                        } else if (!isNaN(parseFloat(e.target.value))) {
                          setFieldValue(
                            'minimum_purchase_amount',
                            parseFloat(e.target.value),
                          );
                          if (
                            toLower(values.deal_type) ===
                            'delivery_fee_discount'
                          ) {
                            setFieldValue(
                              'name',
                              `Free Delivery when you spend $${e.target.value}`,
                            );
                          }
                          if (
                            toLower(values.deal_type) === 'flat_amount_discount'
                          ) {
                            setFieldValue(
                              'name',
                              e.target.value !== '0'
                                ? `Spend $${e.target.value} and Save $${values.value}`
                                : `Top Offer - $${values.value} off`,
                            );
                          }
                          if (
                            toLower(values.deal_type) === 'percentage_discount'
                          ) {
                            setFieldValue(
                              'name',
                              e.target.value !== '0'
                                ? `Spend $${e.target.value} and Save ${values.value}%`
                                : `Top Offer - ${values.value}% off`,
                            );
                          }
                        }
                      }}
                      errors={errors.minimum_purchase_amount}
                      touched={touched.minimum_purchase_amount}
                      disableToastMessage
                    />
                    <div style={{ marginRight: '1rem' }} />

                    <InputAddOn
                      addonsText="$"
                      isLeft
                      type="number"
                      min="0"
                      required
                      label="Discount Amount"
                      value={values.value}
                      onBlur={e => {
                        if (e.target.value === '') {
                          setFieldValue('value', null);
                        } else if (!isNaN(parseFloat(e.target.value))) {
                          setFieldValue(
                            'value',
                            parseFloat(e.target.value).toFixed(2),
                          );
                        }
                      }}
                      onChange={e => {
                        if (e.target.value === '') {
                          setFieldValue('value', null);
                        } else if (!isNaN(parseFloat(e.target.value))) {
                          setFieldValue('value', parseFloat(e.target.value));
                          if (
                            toLower(values.deal_type) === 'flat_amount_discount'
                          ) {
                            setFieldValue(
                              'name',
                              values.minimum_purchase_amount !== '0.00'
                                ? `Spend $${values.minimum_purchase_amount} and Save $${e.target.value} `
                                : `Top Offer - $${e.target.value} off`,
                            );
                          }
                        }
                      }}
                      errors={errors.value}
                      touched={touched.value}
                      disableToastMessage
                    />
                  </div>
                )}
                {values.fee_type === 'PERCENTAGE' && !values.free_delivery && (
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      marginTop: '1rem',
                    }}
                  >
                    <InputAddOn
                      addonsText="$"
                      isLeft
                      required
                      type="number"
                      min="0"
                      label="Minimum purchase amount"
                      value={values.minimum_purchase_amount}
                      onBlur={e => {
                        if (e.target.value === '') {
                          setFieldValue('minimum_purchase_amount', null);
                        } else if (!isNaN(parseFloat(e.target.value))) {
                          setFieldValue(
                            'minimum_purchase_amount',
                            parseFloat(e.target.value).toFixed(2),
                          );
                        }
                      }}
                      onChange={e => {
                        if (e.target.value === '') {
                          setFieldValue('minimum_purchase_amount', null);
                        } else if (!isNaN(parseFloat(e.target.value))) {
                          setFieldValue(
                            'minimum_purchase_amount',
                            parseFloat(e.target.value),
                          );
                          if (
                            toLower(values.deal_type) ===
                            'delivery_fee_discount'
                          ) {
                            setFieldValue(
                              'name',
                              `Free Delivery when you spend $${e.target.value}`,
                            );
                          }
                          if (
                            toLower(values.deal_type) === 'flat_amount_discount'
                          ) {
                            setFieldValue(
                              'name',
                              e.target.value !== '0'
                                ? `Spend $${e.target.value} and Save $${values.value}`
                                : `Top Offer - $${values.value} off`,
                            );
                          }
                          if (
                            toLower(values.deal_type) === 'percentage_discount'
                          ) {
                            setFieldValue(
                              'name',
                              e.target.value !== '0'
                                ? `Spend $${e.target.value} and Save ${values.value}%`
                                : `Top Offer - ${values.value}% off`,
                            );
                          }
                        }
                      }}
                      errors={errors.minimum_purchase_amount}
                      touched={touched.minimum_purchase_amount}
                      disableToastMessage
                    />

                    <div style={{ marginRight: '1rem' }} />

                    <InputAddOn
                      addonsText="%"
                      isRight
                      type="number"
                      min="0"
                      id="DiscountPercentage"
                      label="Discount Percentage"
                      required
                      value={values.value}
                      onChange={e => {
                        if (e.target.value === '') {
                          setFieldValue('value', null);
                        } else if (!isNaN(parseFloat(e.target.value))) {
                          setFieldValue('value', parseFloat(e.target.value));
                          setFieldValue(
                            'name',
                            values.minimum_purchase_amount !== '0.00'
                              ? `Spend $${values.minimum_purchase_amount} and Save ${e.target.value}%`
                              : `Top Offer - ${e.target.value}% off`,
                          );
                        }
                      }}
                      errors={errors.value}
                      touched={touched.value}
                      disableToastMessage
                    />
                  </div>
                )}
                {values.free_delivery && (
                  <>
                    <div style={{ marginTop: '1rem' }} />
                    <InputAddOn
                      addonsText="$"
                      isLeft
                      required
                      type="number"
                      min="0"
                      label="Minimum purchase amount"
                      value={values.minimum_purchase_amount}
                      onBlur={e => {
                        if (e.target.value === '') {
                          setFieldValue('minimum_purchase_amount', null);
                        } else if (!isNaN(parseFloat(e.target.value))) {
                          setFieldValue(
                            'minimum_purchase_amount',
                            parseFloat(e.target.value).toFixed(2),
                          );
                        }
                      }}
                      onChange={e => {
                        if (e.target.value === '') {
                          setFieldValue('minimum_purchase_amount', null);
                        } else if (!isNaN(parseFloat(e.target.value))) {
                          setFieldValue(
                            'minimum_purchase_amount',
                            parseFloat(e.target.value),
                          );
                          if (
                            toLower(values.deal_type) ===
                            'delivery_fee_discount'
                          ) {
                            setFieldValue(
                              'name',
                              `Free Delivery when you spend $${e.target.value}`,
                            );
                          }
                          if (
                            toLower(values.deal_type) === 'flat_amount_discount'
                          ) {
                            setFieldValue(
                              'name',
                              e.target.value !== '0'
                                ? `Spend $${e.target.value} and Save $${values.value}`
                                : `Top Offer - $${values.value} off`,
                            );
                          }
                          if (
                            toLower(values.deal_type) === 'percentage_discount'
                          ) {
                            setFieldValue(
                              'name',
                              e.target.value !== '0'
                                ? `Spend $${e.target.value} and Save ${values.value}%`
                                : `Top Offer - ${values.value}% off`,
                            );
                          }
                        }
                      }}
                      errors={errors.minimum_purchase_amount}
                      touched={touched.minimum_purchase_amount}
                      disableToastMessage
                    />
                  </>
                )}
              </Column>
            )}

            {toLower(values.deal_type) !== 'delivery_fee_discount' && (
              <Column size={3}>
                <InputAddOn
                  addonsText="$"
                  isLeft
                  required
                  type="number"
                  min="0"
                  label="Minimum purchase amount"
                  value={values.minimum_purchase_amount}
                  onBlur={e => {
                    if (e.target.value === '') {
                      setFieldValue('minimum_purchase_amount', null);
                    } else if (!isNaN(parseFloat(e.target.value))) {
                      setFieldValue(
                        'minimum_purchase_amount',
                        parseFloat(e.target.value).toFixed(2),
                      );
                    }
                  }}
                  onChange={e => {
                    if (e.target.value === '') {
                      setFieldValue('minimum_purchase_amount', null);
                    } else if (!isNaN(parseFloat(e.target.value))) {
                      setFieldValue(
                        'minimum_purchase_amount',
                        parseFloat(e.target.value),
                      );
                      if (
                        toLower(values.deal_type) === 'delivery_fee_discount'
                      ) {
                        setFieldValue(
                          'name',
                          `Free Delivery when you spend $${e.target.value}`,
                        );
                      }
                      if (
                        toLower(values.deal_type) === 'flat_amount_discount'
                      ) {
                        setFieldValue(
                          'name',
                          e.target.value !== '0'
                            ? `Spend $${e.target.value} and Save $${values.value}`
                            : `Top Offer - $${values.value} off`,
                        );
                      }
                      if (toLower(values.deal_type) === 'percentage_discount') {
                        setFieldValue(
                          'name',
                          e.target.value !== '0'
                            ? `Spend $${e.target.value} and Save ${values.value}%`
                            : `Top Offer - ${values.value}% off`,
                        );
                      }
                    }
                  }}
                  errors={errors.minimum_purchase_amount}
                  touched={touched.minimum_purchase_amount}
                  disableToastMessage
                />
              </Column>
            )}
            {(toLower(values.deal_type) === 'flat_amount_discount' ||
              toLower(values.deal_type) === 'percentage_discount') && (
              <>
                <Column size={3}>
                  {toLower(values.deal_type) === 'flat_amount_discount' && (
                    <InputAddOn
                      addonsText="$"
                      isLeft
                      type="number"
                      min="0"
                      required
                      label="Discount Amount"
                      value={values.value}
                      onBlur={e => {
                        if (e.target.value === '') {
                          setFieldValue('value', null);
                        } else if (!isNaN(parseFloat(e.target.value))) {
                          setFieldValue(
                            'value',
                            parseFloat(e.target.value).toFixed(2),
                          );
                        }
                      }}
                      onChange={e => {
                        if (e.target.value === '') {
                          setFieldValue('value', null);
                        } else if (!isNaN(parseFloat(e.target.value))) {
                          setFieldValue('value', parseFloat(e.target.value));
                          if (
                            toLower(values.deal_type) === 'flat_amount_discount'
                          ) {
                            setFieldValue(
                              'name',

                              values.minimum_purchase_amount !== '0.00'
                                ? `Spend $${values.minimum_purchase_amount} and Save $${e.target.value} `
                                : `Top Offer - $${e.target.value} off`,
                            );
                          }
                        }
                      }}
                      errors={errors.value}
                      touched={touched.value}
                      disableToastMessage
                    />
                  )}
                  {toLower(values.deal_type) === 'percentage_discount' && (
                    <InputAddOn
                      addonsText="%"
                      isRight
                      type="number"
                      min="0"
                      id="DiscountPercentage"
                      label="Discount Percentage"
                      required
                      value={values.value}
                      onChange={e => {
                        if (e.target.value === '') {
                          setFieldValue('value', null);
                        } else if (!isNaN(parseFloat(e.target.value))) {
                          setFieldValue('value', parseFloat(e.target.value));
                          setFieldValue(
                            'name',
                            values.minimum_purchase_amount !== '0.00'
                              ? `Spend $${values.minimum_purchase_amount} and Save ${e.target.value}%`
                              : `Top Offer - ${e.target.value}% off`,
                          );
                        }
                      }}
                      errors={errors.value}
                      touched={touched.value}
                      disableToastMessage
                    />
                  )}
                </Column>
                <Column size={3}>
                  {toLower(values.deal_type) === 'percentage_discount' && (
                    <InputAddOn
                      addonsText="$"
                      isLeft
                      type="number"
                      id="MaximumDiscountAmount"
                      label="Maximum discount amount"
                      value={values.maximum_discount_amount}
                      onBlur={e => {
                        if (e.target.value === '') {
                          setFieldValue('maximum_discount_amount', null);
                        } else if (!isNaN(parseFloat(e.target.value))) {
                          setFieldValue(
                            'maximum_discount_amount',
                            parseFloat(e.target.value).toFixed(2),
                          );
                        }
                      }}
                      onChange={e => {
                        if (e.target.value === '') {
                          setFieldValue('maximum_discount_amount', null);
                        } else if (!isNaN(parseFloat(e.target.value))) {
                          setFieldValue(
                            'maximum_discount_amount',
                            parseFloat(e.target.value),
                          );
                        }
                      }}
                      errors={errors.maximum_discount_amount}
                      touched={touched.maximum_discount_amount}
                      disableToastMessage
                      required
                    />
                  )}
                </Column>
              </>
            )}
          </Column.Group>
          <p className="is-size-4">
            Discount amount cannot exceed 70% of minimum purchase
          </p>
        </BoxWithHeader>
      )}
      {isBogo && (
        <BoxWithHeader title="Offer Details">
          <Column.Group vcentered multiline>
            <Column size={3}>
              <RadioWrapper>
                <Radio
                  label="Buy 1 get 1 free"
                  value={values.offer_details === 'BUY_X_GET_Y_SAME_ITEM'}
                  onChange={value => {
                    if (value) {
                      setFieldValue('offer_details', 'BUY_X_GET_Y_SAME_ITEM');
                      setFieldValue('buy_quantity', 1);
                      setFieldValue('get_quantity', 1);
                      setFieldValue('selectedLinkIds', []);
                      setFieldValue('menu_item', []);
                      setFieldValue('selectedGetLinkIds', []);
                      setFieldValue('get_menu_item', []);
                    }
                  }}
                  disabled={isUpdate}
                />
              </RadioWrapper>
            </Column>
            <Column size={3}>
              <RadioWrapper>
                <Radio
                  label="Buy 1 get a free item"
                  value={values.offer_details === 'BUY_X_GET_Y_FROM_LIST'}
                  onChange={value => {
                    if (value) {
                      setFieldValue('offer_details', 'BUY_X_GET_Y_FROM_LIST');
                      setFieldValue('buy_quantity', 1);
                      setFieldValue('get_quantity', 1);
                      setFieldValue('selectedLinkIds', []);
                      setFieldValue('menu_item', []);
                      setFieldValue('selectedGetLinkIds', []);
                      setFieldValue('get_menu_item', []);
                    }
                  }}
                  disabled={isUpdate}
                />
              </RadioWrapper>
            </Column>
            <Column size={5}>
              <div className="is-flex mt-1">
                <div className="mt-2">
                  <Radio
                    value={
                      values.offer_details === 'BUY_X_GET_Y_BILL_HIGH_PRICE'
                    }
                    onChange={value => {
                      if (value) {
                        setFieldValue(
                          'offer_details',
                          'BUY_X_GET_Y_BILL_HIGH_PRICE',
                        );
                        setFieldValue('buy_quantity', 1);
                        setFieldValue('get_quantity', 1);
                        setFieldValue('selectedLinkIds', []);
                        setFieldValue('menu_item', []);
                        setFieldValue('selectedGetLinkIds', []);
                        setFieldValue('get_menu_item', []);
                      }
                    }}
                    disabled={isUpdate}
                  />
                </div>
                <span className="label has-text-grey has-text-weight-normal is-flex p-2">
                  Buy&nbsp;
                </span>
                <Input
                  style={{ width: '100px' }}
                  addonsText=""
                  isLeft
                  type="number"
                  min="0"
                  required
                  value={values.buy_quantity}
                  onBlur={e => {
                    if (e.target.value === '') {
                      setFieldValue('buy_quantity', null);
                    } else if (!isNaN(parseFloat(e.target.value))) {
                      setFieldValue('buy_quantity', e.target.value);
                    }
                  }}
                  onChange={e => {
                    if (e.target.value === '') {
                      setFieldValue('buy_quantity', null);
                    } else if (!isNaN(parseFloat(e.target.value))) {
                      setFieldValue('buy_quantity', e.target.value);
                    }
                  }}
                  errors={errors.buy_quantity}
                  touched={touched.buy_quantity}
                  disableToastMessage
                  disabled={
                    values.offer_details !== 'BUY_X_GET_Y_BILL_HIGH_PRICE'
                  }
                />
                <span className="label has-text-grey has-text-weight-normal is-flex p-2">
                  &nbsp;get&nbsp;
                </span>
                <Input
                  style={{ width: '100px' }}
                  addonsText=""
                  isLeft
                  type="number"
                  min="0"
                  required
                  value={values.get_quantity}
                  onBlur={e => {
                    if (e.target.value === '') {
                      setFieldValue('get_quantity', null);
                    } else if (!isNaN(parseFloat(e.target.value))) {
                      setFieldValue('get_quantity', e.target.value);
                    }
                  }}
                  onChange={e => {
                    if (e.target.value === '') {
                      setFieldValue('get_quantity', null);
                    } else if (!isNaN(parseFloat(e.target.value))) {
                      setFieldValue('get_quantity', e.target.value);
                    }
                  }}
                  errors={errors.get_quantity}
                  touched={touched.get_quantity}
                  disableToastMessage
                  disabled={
                    values.offer_details !== 'BUY_X_GET_Y_BILL_HIGH_PRICE'
                  }
                />
                <span
                  style={{ whiteSpace: 'nowrap' }}
                  className="label has-text-grey has-text-weight-normal is-flex p-2"
                >
                  &nbsp;free items&nbsp;
                </span>
              </div>
            </Column>
          </Column.Group>
          {values.offer_details !== 'BUY_X_GET_Y_FROM_LIST' && (
            <Column.Group vcentered>
              <Column size={3}>
                <Input
                  disabled={disableMaximumFreeQuantity}
                  addonsText=""
                  isLeft
                  type="number"
                  min="0"
                  required
                  label="Offer per order"
                  value={values.maximum_free_quantity}
                  onBlur={e => {
                    if (e.target.value === '') {
                      setFieldValue('maximum_free_quantity', null);
                    } else if (!isNaN(parseFloat(e.target.value))) {
                      setFieldValue('maximum_free_quantity', e.target.value);
                    }
                  }}
                  onChange={e => {
                    if (e.target.value === '') {
                      setFieldValue('maximum_free_quantity', null);
                    } else if (!isNaN(parseFloat(e.target.value))) {
                      setFieldValue('maximum_free_quantity', e.target.value);
                    }
                  }}
                  errors={errors.maximum_free_quantity}
                  touched={touched.maximum_free_quantity}
                  disableToastMessage
                />
              </Column>
            </Column.Group>
          )}
        </BoxWithHeader>
      )}

      {addGetItemModalIsActive && (
        <SearchItemModal
          minimumPriceToCompare={minimumPrice}
          isOfferItem
          isBogoDeal={isBogo}
          menuId={values.menu_id}
          placeId={values.place_id}
          isSubmitting={addItemsSubmitting}
          initialsItems={values.selectedGetLinkIds}
          isActive={addGetItemModalIsActive}
          onClose={() => setAddGetItemModalIsActive(false)}
          onSubmit={async val => {
            setAddItemsSubmitting(true);
            const { selectedItems, discountType, discountValue } = val;

            const selectedItemsMap = new Map();

            if (Array.isArray(selectedItems)) {
              selectedItems.forEach(ele => {
                const { meta_data, ...eleRest } = ele;
                selectedItemsMap.set(
                  ele.item_link_id,
                  onAddItems(eleRest, discountType, discountValue),
                );
              });
            }

            setLinks(
              links.map(ele => {
                if (selectedItemsMap.get(ele.item_link_id)) {
                  return selectedItemsMap.get(ele.item_link_id);
                }
                return ele;
              }),
            );

            if (isBogo) {
              setFieldValue('selectedGetLinkIds', [
                ...[...selectedItemsMap.keys()],
              ]);

              setFieldValue('get_menu_item', [...selectedItemsMap.values()]);
            } else {
              setFieldValue('selectedGetLinkIds', [
                ...[...selectedItemsMap.keys()],
                ...values.selectedGetLinkIds,
              ]);

              setFieldValue('get_menu_item', [
                ...selectedItemsMap.values(),
                ...values.get_menu_item,
              ]);
            }

            setAddItemsSubmitting(false);
            setAddGetItemModalIsActive(false);
          }}
        />
      )}
      {addItemModalIsActive && (
        <SearchItemModal
          isBogoDeal={isBogo}
          isSelectFromListOffer={
            values.offer_details === 'BUY_X_GET_Y_FROM_LIST'
          }
          menuId={values.menu_id}
          placeId={values.place_id}
          isSubmitting={addItemsSubmitting}
          initialsItems={values.selectedLinkIds}
          isActive={addItemModalIsActive}
          onClose={() => setAddItemModalIsActive(false)}
          onSubmit={async val => {
            setAddItemsSubmitting(true);
            const { selectedItems, discountType, discountValue } = val;

            const selectedItemsMap = new Map();

            if (Array.isArray(selectedItems)) {
              selectedItems.forEach(ele => {
                const { meta_data, ...eleRest } = ele;
                selectedItemsMap.set(
                  ele.item_link_id,
                  onAddItems(eleRest, discountType, discountValue),
                );
              });
            }

            setLinks(
              links.map(ele => {
                if (selectedItemsMap.get(ele.item_link_id)) {
                  return selectedItemsMap.get(ele.item_link_id);
                }
                return ele;
              }),
            );

            if (isBogo) {
              setFieldValue('selectedLinkIds', [
                ...[...selectedItemsMap.keys()],
              ]);

              setFieldValue('menu_item', [...selectedItemsMap.values()]);
            } else {
              setFieldValue('selectedLinkIds', [
                ...[...selectedItemsMap.keys()],
                ...values.selectedLinkIds,
              ]);

              setFieldValue('menu_item', [
                ...selectedItemsMap.values(),
                ...values.menu_item,
              ]);
            }

            setAddItemsSubmitting(false);
            setAddItemModalIsActive(false);
          }}
        />
      )}
      {addCategoryModalIsActive && (
        <AddCategoryModal
          isSubmitting={false}
          initialsItems={values.selectedCategories}
          isActive={addCategoryModalIsActive}
          onClose={() => setAddCategoryModalIsActive(false)}
          onSubmit={async val => {
            setAddItemsSubmitting(true);

            const { selectedItems, discountType, discountValue } = val;

            const selectedItemsSet = new Set(
              selectedItems.map(ele => ele.name),
            );

            setFieldValue('selectedCategories', [
              ...(values.selectedCategories || []),
              ...selectedItems.map(ele => ({
                category_name: ele.name,
                category_id: ele.menu_section_id,
              })),
            ]);

            const temp = [];
            const temp2 = [];

            values.linksForCategory.forEach(ele => {
              if (selectedItemsSet.has(ele.menu_section_name)) {
                temp2.push(ele.item_link_id);
                temp.push(onAddItems(ele, discountType, discountValue));
              } else {
                temp.push(ele);
              }
            });

            setFieldValue('linksForCategory', temp);
            setFieldValue('linksForCategoryIsDirty', true);

            setAddItemsSubmitting(false);
            setAddCategoryModalIsActive(false);
          }}
          placeId={values.place_id}
          menuId={values.menu_id}
          userId={values.user_id}
        />
      )}
      {toLower(values.deal_type) === 'specific_item_discount' && !linksLoading && (
        <div style={{ margin: '1rem' }}>
          <button
            type="button"
            className="button is-primary"
            onClick={() => {
              setAddItemModalIsActive(true);
            }}
          >
            <span className="icon">
              <i className="fa fa-plus" />
            </span>
            <span>Add Item(s)</span>
          </button>
        </div>
      )}
      {isBogo && !linksLoading && (
        <div style={{ margin: '1rem' }}>
          <button
            type="button"
            className="button is-primary"
            onClick={() => {
              setAddItemModalIsActive(true);
            }}
          >
            <span className="icon">
              <i className="fa fa-plus" />
            </span>
            <span>
              {values.offer_details === 'BUY_X_GET_Y_FROM_LIST' ? (
                <>&nbsp;Buy Item</>
              ) : (
                <>&nbsp;Buy Item(s)</>
              )}
            </span>
          </button>
        </div>
      )}
      {(toLower(values.deal_type) === 'specific_item_discount' || isBogo) &&
        linksLoading && (
          <LoaderWrapper>
            <ReactLoading
              type="spin"
              color="#505050"
              height="3rem"
              width="3rem"
            />
          </LoaderWrapper>
        )}
      {toLower(values.deal_type) === 'specific_item_discount' &&
        !linksLoading &&
        links && (
          <ItemsAndVariantsDiscount
            linksLoading={linksLoading}
            links={links}
            setFieldValue={setFieldValue}
            menu_item={values.menu_item}
            selectedLinkIds={values.selectedLinkIds}
            isBogoDeal={isBogo}
          />
        )}
      {isBogo && !linksLoading && links && (
        <BogoItems
          linksLoading={linksLoading}
          links={links}
          setFieldValue={setFieldValue}
          menu_item={values.menu_item}
          selectedLinkIds={values.selectedLinkIds}
          onEdit={() => setAddItemModalIsActive(true)}
        />
      )}
      {values.offer_details === 'BUY_X_GET_Y_FROM_LIST' && !linksLoading && (
        <div style={{ margin: '1rem' }}>
          <button
            type="button"
            className="button is-primary"
            onClick={() => {
              setAddGetItemModalIsActive(true);
            }}
            disabled={values.menu_item.length === 0}
          >
            <span className="icon">
              <i className="fa fa-plus" />
            </span>
            <span>&nbsp;Get Item(s)</span>
          </button>
          <div className="mt-2">
            {values.menu_item.length === 0 && (
              <span className="has-text-danger">
                Select a Buy Item before adding Get Item(s)
              </span>
            )}
          </div>
        </div>
      )}

      {values.offer_details === 'BUY_X_GET_Y_FROM_LIST' &&
        !linksLoading &&
        links && (
          <BogoItems
            linksLoading={linksLoading}
            links={links}
            setFieldValue={setFieldValue}
            menu_item={values.get_menu_item}
            selectedLinkIds={values.selectedGetLinkIds}
            onEdit={() => setAddItemModalIsActive(true)}
          />
        )}
      {toLower(values.deal_type) === 'specific_item_discount' && !linksLoading && (
        <div style={{ margin: '1rem' }}>
          <button
            type="button"
            className="button is-primary"
            onClick={() => {
              setAddCategoryModalIsActive(true);
            }}
          >
            <span className="icon">
              <i className="fa fa-plus" />
            </span>
            <span>&nbsp;Add Item(s) from Category</span>
          </button>
        </div>
      )}

      {toLower(values.deal_type) === 'specific_item_discount' &&
        !linksLoading &&
        links &&
        Array.isArray(links) &&
        links.length !== 0 && (
          <CategoryDealDiscount
            links={values.linksForCategory}
            menu_item={values.categoryMenuItems}
            selectedCategories={values.selectedCategories}
            linksForCategoryIsDirty={values.linksForCategoryIsDirty}
            setLinks={v => {
              setFieldValue('linksForCategory', v);
            }}
            setFieldValue={setFieldValue}
          />
        )}
      <Column.Group>
        <Column size={9}>
          <Input
            label="Deal/Voucher Tagline"
            name="name"
            required
            id="VoucherTagline"
            value={values.name}
            onChange={handleChange}
            onBlur={handleBlur}
            errors={errors.name}
            touched={touched.name}
            disabled={isBogo}
            // disabled={toLower(values.deal_type) === 'specific_item_discount'}
          />
        </Column>
      </Column.Group>
      <Column.Group>
        <Column size={5}>
          <DealTimeDatePicker
            label="Start Date"
            timeLabel="Start Time"
            date={values.startDate}
            time={values.startTime}
            onDateChange={value => {
              setFieldValue('startDate', value);
            }}
            onTimeChange={value => {
              setFieldValue('startTime', value ? moment(value) : null);
            }}
            minDate={new Date()}
            errors={errors.startDate}
            touched={touched.startDate}
            required
          />
        </Column>
        <Column size={5}>
          <DealTimeDatePicker
            label="End Date"
            timeLabel="End Time"
            date={values.endDate}
            time={values.endTime}
            onDateChange={value => {
              setFieldValue('endDate', value);
            }}
            onTimeChange={value => {
              setFieldValue('endTime', value ? moment(value) : null);
            }}
            minDate={new Date(values.startDate)}
            errors={errors.endDate}
            touched={touched.endDate}
            disabled={values.startDate === null}
            required
          />
        </Column>
      </Column.Group>
      {![
        'buy_one_get_one_promo',
        'specific_item_discount',
        'listing_only',
      ].find(ele => ele === values.deal_type) && (
        <>
          <Column.Group>
            <Column size={5}>
              <BoxWithHeader style={{ fontSize: '10px' }} title="Budget">
                <Radio
                  label="Unlimited"
                  value={values.is_maximum_budget_unlimited}
                  onChange={value => {
                    if (value) {
                      setFieldValue('is_maximum_budget_unlimited', true);
                      setFieldValue('maximum_budget', 0);
                    }
                  }}
                />
                <Radio
                  label="Max Budget"
                  value={!values.is_maximum_budget_unlimited}
                  onChange={value => {
                    if (value) {
                      setFieldValue('is_maximum_budget_unlimited', false);
                      setFieldValue('maximum_budget', 1);
                    }
                  }}
                />
                {!values.is_maximum_budget_unlimited && (
                  <div style={{ width: '50%' }}>
                    <Input
                      type="number"
                      min="0"
                      value={values.maximum_budget}
                      onChange={e => {
                        setFieldValue('maximum_budget', e.target.value);
                      }}
                      onBlur={e => {
                        e.preventDefault();
                        const targetValue = parseInt(e.target.value, 10);

                        if (!targetValue) {
                          alert(`Please enter a valid maximum budget`);
                          setFieldValue('maximum_budget', 1);
                        }
                      }}
                    />
                  </div>
                )}
              </BoxWithHeader>
            </Column>
            <Column size={5}>
              <BoxWithHeader
                style={{ fontSize: '10px' }}
                title="No of discount per user"
              >
                <Radio
                  label="Unlimited"
                  value={values.is_maximum_no_of_discounts_per_user_unlimited}
                  onChange={value => {
                    if (value) {
                      setFieldValue(
                        'is_maximum_no_of_discounts_per_user_unlimited',
                        true,
                      );
                      setFieldValue('maximum_no_of_discounts_per_user', 0);
                    }
                  }}
                />
                <Radio
                  label="Maximum number of discounts"
                  value={!values.is_maximum_no_of_discounts_per_user_unlimited}
                  onChange={value => {
                    if (value) {
                      setFieldValue(
                        'is_maximum_no_of_discounts_per_user_unlimited',
                        false,
                      );
                      setFieldValue('maximum_no_of_discounts_per_user', 1);
                    }
                  }}
                />
                {!values.is_maximum_no_of_discounts_per_user_unlimited && (
                  <div style={{ width: '50%' }}>
                    <Input
                      type="number"
                      min="0"
                      value={values.maximum_no_of_discounts_per_user}
                      onChange={e => {
                        setFieldValue(
                          'maximum_no_of_discounts_per_user',
                          e.target.value,
                        );
                      }}
                      onBlur={e => {
                        e.preventDefault();
                        const targetValue = parseInt(e.target.value, 10);

                        if (!targetValue) {
                          alert(
                            `Please enter a valid maximum number of discounts per user`,
                          );
                          setFieldValue('maximum_no_of_discounts_per_user', 1);
                        }
                      }}
                    />
                  </div>
                )}
              </BoxWithHeader>
            </Column>
          </Column.Group>
          <Column.Group>
            <Column size={5}>
              <BoxWithHeader
                style={{ fontSize: '10px' }}
                title="No of discounts"
              >
                <Radio
                  label="Unlimited"
                  value={values.is_maximum_no_of_discounts_unlimited}
                  onChange={value => {
                    if (value) {
                      setFieldValue(
                        'is_maximum_no_of_discounts_unlimited',
                        true,
                      );
                      setFieldValue('maximum_no_of_discounts', 0);
                    }
                  }}
                />
                <Radio
                  label="Maximum number of discounts"
                  value={!values.is_maximum_no_of_discounts_unlimited}
                  onChange={value => {
                    if (value) {
                      setFieldValue(
                        'is_maximum_no_of_discounts_unlimited',
                        false,
                      );
                      setFieldValue('maximum_no_of_discounts', 1);
                    }
                  }}
                />
                {!values.is_maximum_no_of_discounts_unlimited && (
                  <div style={{ width: '50%' }}>
                    <Input
                      type="number"
                      min="0"
                      value={values.maximum_no_of_discounts}
                      onChange={e => {
                        setFieldValue(
                          'maximum_no_of_discounts',
                          e.target.value,
                        );
                      }}
                      onBlur={e => {
                        e.preventDefault();
                        const targetValue = parseInt(e.target.value, 10);

                        if (!targetValue) {
                          alert(
                            `Please enter a valid maximum number of discounts`,
                          );
                          setFieldValue('maximum_no_of_discounts', 1);
                        }
                      }}
                    />
                  </div>
                )}
              </BoxWithHeader>
            </Column>
          </Column.Group>
        </>
      )}
    </>
  );
};

export default VoucherDetails;
